const CACHE_TTL_MS = 5 * 60 * 1000

let cachedResponse = null
let cacheTimestamp = 0
let inFlightPromise = null

export function clearAssignedInstitutesCache() {
  cachedResponse = null
  cacheTimestamp = 0
  inFlightPromise = null
}

/**
 * Wrap a GET /users/institute request with in-flight dedup + short TTL cache.
 */
export function withAssignedInstitutesCache(requestFn, { force = false } = {}) {
  const now = Date.now()
  if (!force && cachedResponse && now - cacheTimestamp < CACHE_TTL_MS) {
    return Promise.resolve(cachedResponse)
  }
  if (!force && inFlightPromise) {
    return inFlightPromise
  }

  inFlightPromise = requestFn()
    .then((response) => {
      cachedResponse = response
      cacheTimestamp = Date.now()
      return response
    })
    .finally(() => {
      inFlightPromise = null
    })

  return inFlightPromise
}
